import {
	DELETE_FAILED_USERS_FAILURE,
	DELETE_FAILED_USERS_REQUEST,
	DELETE_FAILED_USERS_SUCCESS,
	DELETE_PL9_HARDWARE_FAILURE,
	DELETE_PL9_HARDWARE_REQUEST,
	DELETE_PL9_HARDWARE_SUCCESS,
	GET_FAILED_USERS_FAILURE,
	GET_FAILED_USERS_LENGTH_FAILURE,
	GET_FAILED_USERS_LENGTH_REQUEST,
	GET_FAILED_USERS_LENGTH_SUCCESS,
	GET_FAILED_USERS_REQUEST,
	GET_FAILED_USERS_SUCCESS,
	PL9_HARDWARE_FAILURE,
	PL9_HARDWARE_REQUEST,
	PL9_HARDWARE_SUCCESS,
} from "./pl9HardwareConstant";

export const pl9HardwareCommandsReducer = (
	initialState = {
		pl9HardwareCommands: [],
	},
	action
) => {
	switch (action.type) {
		case PL9_HARDWARE_REQUEST:
			return { ...initialState, getPL9Loading: true };
		case PL9_HARDWARE_SUCCESS:
			return {
				...initialState,
				getPL9Loading: false,
				pl9HardwareCommands: action?.payload?.data?.result || [],
			};
		case PL9_HARDWARE_FAILURE:
			return {
				...initialState,
				getPL9Loading: false,
				getPL9Error: action.payload,
			};

		case DELETE_PL9_HARDWARE_REQUEST:
			return { ...initialState, deletePL9Loading: true };
		case DELETE_PL9_HARDWARE_SUCCESS:
			return {
				...initialState,
				deletePL9Loading: false,
			};
		case DELETE_PL9_HARDWARE_FAILURE:
			return {
				...initialState,
				deletePL9Loading: false,
				deletePL9Error: action.payload,
			};

		case GET_FAILED_USERS_REQUEST:
			return {
				...initialState,
				failedUserLoading: true,
				getFailedUsers: [],
			};
		case GET_FAILED_USERS_SUCCESS:
			return {
				...initialState,
				data: action.payload.result,
				getFailedUsers: action.payload.result.data,
				failedUserLoading: false,
			};
		case GET_FAILED_USERS_FAILURE:
			return {
				...initialState,
				failedUserLoading: false,
				getFailedUserError: action.payload,
			};

		case DELETE_FAILED_USERS_REQUEST:
			return {
				...initialState,
				deletefailedUserLoading: true,
			};
		case DELETE_FAILED_USERS_SUCCESS:
			return {
				...initialState,
				deletefailedUserLoading: false,
			};
		case DELETE_FAILED_USERS_FAILURE:
			return {
				...initialState,
				failedUserLoading: false,
				deleteFailedUserError: action.payload,
			};

		case GET_FAILED_USERS_LENGTH_REQUEST:
			return {
				...initialState,
				failedUserLengthLoading: true,
			};
		case GET_FAILED_USERS_LENGTH_SUCCESS:
			console.log(action.payload,"payload")
			return {
				...initialState,
				failedUsersLength: action.payload.result.data,
				failedUserLengthLoading: false,
			};
		case GET_FAILED_USERS_LENGTH_FAILURE:
			return {
				...initialState,
				failedUserLengthLoading: false,
				getFailedUserLengthError: action.payload,
			};

		default:
			return initialState;
	}
};
